import React from 'react';
import { useTranslation } from "@/lib/i18n";

export default function CanvasToolIndicator({activeTool, theme = 'dark'}) {
  const { t } = useTranslation('editor');

  const getToolName = (tool) => {
    const key = `sidebar.tool_${tool.replace('-', '_')}`;
    const translated = t(key);
    return translated !== key ? translated : tool;
  };

  return (
    <div className={`absolute top-8 left-3 z-30 flex items-center gap-1.5 backdrop-blur px-2.5 py-1.5 rounded-lg text-xs transition-colors duration-300 ${
      theme === 'dark' 
        ? 'bg-zinc-950/80 border-zinc-800 text-zinc-300' 
        : 'bg-white/80 border-slate-200 text-slate-600 shadow-sm'
    } border`}>
      <span className={theme === 'dark' ? 'text-zinc-500' : 'text-slate-400'}>{t('canvas.tool_indicator')}:</span>
      <span className={`${theme === 'dark' ? 'text-cyan-400' : 'text-indigo-600'} font-semibold`}>{getToolName(activeTool)}</span>
    </div>
  );
}